var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(1630 25)",
    fill: "#efa7a7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1630 -25)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.887,17.076l-.306.545H9.576l-.019-.011-.07-.04c-.06-.035-.148-.087-.258-.154-.221-.134-.534-.331-.909-.584a25.289,25.289,0,0,1-2.755-2.139c-1.971-1.774-4.113-4.357-4.113-7.3A4.688,4.688,0,0,1,9.887,4.576a4.688,4.688,0,0,1,8.438,2.813c0,2.944-2.142,5.527-4.113,7.3a25.286,25.286,0,0,1-2.754,2.139c-.375.253-.689.449-.909.584-.11.067-.2.119-.258.154l-.07.04-.019.011H10.2S10.193,17.622,9.887,17.076Zm0,0,.305.545a.626.626,0,0,1-.611,0Z",
    transform: "translate(1630.113 24.799)",
    fill: "#da4167",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconFilled);
export default __webpack_public_path__ + "static/media/heart-icon-filled.e49a1c70a62b96dacb494ef957bd6c05.svg";
export { ForwardRef as ReactComponent };